import { useEffect, useState } from "react";
import { AlertTriangle, RefreshCw, Mail, Phone, FileText, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const ACTION_LABELS = {
  retry_carta: { label: "Retry Carta", icon: RefreshCw, color: "sky" },
  email_sms_wa: { label: "Email + SMS + WA", icon: Mail, color: "amber" },
  pec_sollecito: { label: "PEC Sollecito", icon: FileText, color: "rose" },
  recupero_crediti_esterno: { label: "Recupero Esterno", icon: AlertTriangle, color: "fuchsia" },
};

export default function Dunning() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/dunning/pending");
      setItems(r.data || []);
    } catch (e) { toast.error("Errore: " + e.message); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const retry = async (id) => {
    setBusy(id);
    try {
      await api.post(`/dunning/retry/${id}`);
      toast.success("Retry eseguito");
      load();
    } catch (e) { toast.error("Errore: " + e.message); }
    finally { setBusy(null); }
  };

  return (
    <div className="space-y-6" data-testid="dunning-page">
      <div>
        <h1 className="font-display text-3xl font-black uppercase tracking-tight flex items-center gap-3">
          <AlertTriangle className="text-[#ff0033]" size={26} />
          Recupero Crediti Automatico
        </h1>
        <p className="text-sm text-white/45 mt-1">
          Pipeline dunning: T+0 retry carta · T+3 Email/SMS/WA · T+7 PEC sollecito · T+14 recupero crediti esterno.
        </p>
      </div>

      <div className="glass rounded-2xl overflow-hidden">
        {loading && <div className="text-center py-12 text-white/40">Caricamento…</div>}
        {!loading && items.length === 0 && (
          <div className="text-center py-16">
            <div className="text-emerald-300 text-3xl font-display font-black mb-2">🎉</div>
            <div className="text-white/55">Nessun pagamento in sospeso. Bravo!</div>
          </div>
        )}
        {!loading && items.length > 0 && (
          <table className="w-full text-xs" data-testid="dunning-table">
            <thead className="bg-white/[0.04] text-white/55 uppercase tracking-widest text-[10px]">
              <tr>
                <th className="px-3 py-2 text-left">Riferimento</th>
                <th className="px-2 py-2 text-right">Importo</th>
                <th className="px-2 py-2 text-left">Stato</th>
                <th className="px-2 py-2 text-right">Età (giorni)</th>
                <th className="px-2 py-2 text-left">Priorità</th>
                <th className="px-2 py-2 text-left">Prossima azione</th>
                <th className="px-2 py-2 text-center">Esegui</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => {
                const action = ACTION_LABELS[p.next_action] || { label: p.next_action, icon: AlertTriangle, color: "white" };
                const Icon = action.icon;
                return (
                  <tr key={p.id} className="border-t border-white/5">
                    <td className="px-3 py-2">
                      <div className="font-mono text-white/80">{p.fattura_num || p.id?.slice(0, 8)}</div>
                      <div className="text-[10px] text-white/40">{p.descrizione}</div>
                    </td>
                    <td className="px-2 py-2 text-right font-mono font-bold">€{(p.importo || 0).toLocaleString("it-IT")}</td>
                    <td className="px-2 py-2">
                      <span className="text-[10px] uppercase font-bold px-2 py-1 rounded bg-rose-500/15 text-rose-300 border border-rose-500/30">{p.stato}</span>
                    </td>
                    <td className="px-2 py-2 text-right font-mono">{p.age_days}</td>
                    <td className="px-2 py-2">
                      <span className={`text-[10px] uppercase font-bold px-2 py-1 rounded ${
                        p.priority === "critical" ? "bg-rose-500/20 text-rose-300" :
                        p.priority === "high" ? "bg-amber-500/20 text-amber-300" :
                        "bg-sky-500/20 text-sky-300"
                      }`}>{p.priority}</span>
                    </td>
                    <td className="px-2 py-2">
                      <span className="inline-flex items-center gap-1 text-white/80"><Icon size={12} /> {action.label}</span>
                    </td>
                    <td className="px-2 py-2 text-center">
                      <button onClick={() => retry(p.id)} disabled={busy === p.id} data-testid={`dunning-retry-${p.id}`}
                        className="btn-neon px-3 py-1 rounded text-[10px] font-bold disabled:opacity-40">
                        {busy === p.id ? <Loader2 size={12} className="animate-spin inline" /> : <RefreshCw size={11} className="inline" />} Esegui
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
